import React, { useState, useEffect, useRef } from 'react'
import ReactDOM from 'react-dom'
import {
  ActionButtonsStyle,
  InvoiceListSettingsFormStyle,
  DataFillFormStyle,
  RecordsPerPageFormStyle,
  ShowStatusFormStyle
} from './css/InvoiceListSettingsFormStyle'

function DateFilterForm(props) {
  const { app, date, setDate } = props
  const dateCreatedFetchAllBtnRef = useRef(null)
  const defaultDate = {
    from: (new Date(app.getClientDateTime()).getFullYear() + '-01'),
    to: (new Date(app.getClientDateTime()).getFullYear() + '-12')
  }

  useEffect(() => {
    dateCreatedFetchAllBtnRef.current.focus()
  }, [])

  const onChangeDateCreatedCheck = (e) => {
    const fetch_all = date.date_created_fetch_all
    setDate({
      ...date,
      date_created_from: fetch_all ? defaultDate.from : '',
      date_created_to: fetch_all ? defaultDate.to : '',
      date_created_fetch_all: (!fetch_all)
    })
  }

  const onChangeDateModifiedCheck = (e) => {
    const fetch_all = date.date_modified_fetch_all
    setDate({
      ...date,
      date_modified_from: fetch_all ? defaultDate.from : '',
      date_modified_to: fetch_all ? defaultDate.to : '',
      date_modified_fetch_all: (!fetch_all)
    })
  }

  return (
    <React.Fragment>
      <div id='dates' className='form-container'>
        <h4 className='header-caption'>Filter date range</h4>
        <div style={{fontSize: '0.7em', margin: '10px 0', paddingLeft: '10px'}}>
          <p> Will only fetch the data within these ranges of date.</p>
        </div>
        <div id='date-filter-form-container'>

          {/********** DATE CREATED ***********/}
          <div className='date-filter-form'>
            <label>Date Created</label>
            <hr/>
            <div className='date-field-form-container'>
              <div
                id='date-created-fetch-all-container'
                className="checkbox-fetch-all-container">
                <input
                  ref={dateCreatedFetchAllBtnRef}
                  className='top-anchor'
                  id="date-created-checkbox-fetch-all"
                  checked={date.date_created_fetch_all}
                  onChange={onChangeDateCreatedCheck}
                  type="checkbox"
                />
                {' '}
                <button
                  type="button"
                  className='fetch-all-btn'
                  onClick={onChangeDateCreatedCheck}
                  id="date-created-fetch-all-btn">
                  Fetch all
                </button>
              </div>
              <div className='date-from'>
                <label>From</label>
                <input
                  disabled={date.date_created_fetch_all}
                  value={date.date_created_from || ''}
                  onChange={(e) => {
                    setDate({ ...date, date_created_from: e.target.value })
                  }}
                  type='month'
                />
              </div>
              <div className='date-to'>
                <label>To</label>
                <input
                  disabled={date.date_created_fetch_all}
                  value={date.date_created_to || ''}
                  onChange={(e) => {
                    setDate({ ...date, date_created_to: e.target.value })
                  }}
                  type='month'
                />
              </div>
            </div>
          </div>

          <br/>

          {/********** DATE MODIFIED ***********/}
          <div className='date-filter-form'>
            <label>Date Modified</label>
            <hr/>
            <div className='date-field-form-container'>
              <div
                id='date-modified-fetch-all-container'
                className="checkbox-fetch-all-container">
                <input
                  id="date-modified-checkbox-fetch-all"
                  checked={date.date_modified_fetch_all}
                  onChange={onChangeDateModifiedCheck}
                  type="checkbox"
                />
                {' '}
                <button
                  type="button"
                  className='fetch-all-btn'
                  onClick={onChangeDateModifiedCheck}
                  id="date-modified-fetch-all-btn">
                  Fetch all
                </button>
              </div>
              <div className='date-from'>
                <label>From</label>
                <input
                  disabled={date.date_modified_fetch_all}
                  value={date.date_modified_from || ''}
                  onChange={(e) => {
                    setDate({ ...date, date_modified_from: e.target.value })
                  }}
                  type='month'
                />
              </div>
              <div className='date-to'>
                <label>To</label>
                <input
                  disabled={date.date_modified_fetch_all}
                  value={date.date_modified_to || ''}
                  onChange={(e) => {
                    setDate({ ...date, date_modified_to: e.target.value })
                  }}
                  type='month'
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <DataFillFormStyle />
    </React.Fragment>
  )
}

function ShowStatus(props) {
  const { status, setStatus } = props
  const onChangeStatus = (e) => setStatus(e.target.value)

  return (
    <React.Fragment>
      <div id='status' className='form-container'>
        <h4 className='header-caption'>Show Status</h4>
        <div id='status-form'>
          <label>Status</label>
          <select
            value={status}
            onChange={onChangeStatus}>
            <option>Unpaid</option>
            <option>Linked</option>
            <option>Paid</option>
            <option>On Process</option>
            <option>-All-</option>
          </select>
        </div>
      </div>
      <ShowStatusFormStyle />
    </React.Fragment>
  )
}

function RecordsPerPageForm(props) {
  const { recPP, setRecPP } = props
  const onChange = (e) => {
    if (e.target.value) setRecPP(parseInt(e.target.value))
    else setRecPP(e.target.value)
  }

  return (
    <React.Fragment>
      <div id='rpp' className='form-container'>
        <h4 className='header-caption'>Records/Page</h4>
        <div id='rpp-form'>
          <label>Records/Page</label>
          <input
            type='number'
            value={recPP}
            onChange={onChange}
            min='1'
          />
        </div>
      </div>
      <RecordsPerPageFormStyle />
    </React.Fragment>
  )
}

function ActionButtons(props) {
  const saveSettings = props.saveSettings

  return (
    <React.Fragment>
      <div id='buttons' className='form-container'>
        <div id='action-button-container'>
          <button
            onClick={(e) => {
                saveSettings()
                ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container'))
              }}
            className='pospro-action-btn'>
            Apply
          </button>
          <button
            onClick={(e) => {
                ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container'))
              }}
            className='pospro-action-btn bottom-anchor'>
            Close
          </button>
        </div>
      </div>
      <ActionButtonsStyle />
    </React.Fragment>
  )
}

function InvoiceListSettingsForm(props) {
  const { app, invoiceListController } = props
  const invoiceListSettings = invoiceListController.invoiceListSettings

  const [date, setDate] = useState(invoiceListSettings.date)
  const [status, setStatus] = useState(invoiceListSettings.show_invoice_status)
  const [recPP, setRecPP] = useState(invoiceListSettings.record_per_page)

  const saveSettings = () => {
    const settings = { date, show_invoice_status: status, record_per_page: recPP }
    invoiceListController.updateInvoiceListSettings(settings)
  }

  return (
    <React.Fragment>
      <div id='main-container'>
        <div className='content-wrapper'>
          <DateFilterForm app={app} date={date} setDate={setDate} />
          <ShowStatus status={status} setStatus={setStatus} />
          <RecordsPerPageForm recPP={recPP} setRecPP={setRecPP} />
        </div>
        <ActionButtons saveSettings={saveSettings} />
      </div>
      <InvoiceListSettingsFormStyle />
    </React.Fragment>
  )
}

export default React.memo(InvoiceListSettingsForm)